import {
  User,
  MessageCircle,
  Users,
  Building2,
  CreditCard,
  Bell,
  Globe,
  Info,
  Mail,
} from 'lucide-react';

export const SETTINGS_CATEGORIES = [
  { key: 'email', label: 'Email', description: 'Mailbox and shared inbox connection', path: '/settings/email', icon: Mail },
  { key: 'business-knowledge', label: 'Business knowledge', description: 'Business details, instructions, pricing and policies', path: '/settings/business-knowledge', icon: Building2 },
  { key: 'custom-fields', label: 'Custom fields', description: 'Searchable business details on leads and deals', path: '/settings/custom-fields', icon: Building2 },
  { key: 'whatsapp', label: 'WhatsApp', description: 'Business number and inbox connection', path: '/settings/whatsapp', icon: MessageCircle, whatsappOnly: true },
  { key: 'team', label: 'Team & access', description: 'People, invitations, and permissions', path: '/settings/team', icon: Users },
  {
    key: 'account',
    label: 'Account',
    description: 'Profile, email, and logout',
    path: '/settings/account',
    icon: User,
  },
  {
    key: 'workspace',
    label: 'Workspace overview',
    description: 'Your workspace, role, and management tools',
    path: '/settings/workspace',
    icon: Building2,
  },
  {
    key: 'billing',
    label: 'Billing',
    description: 'Plan, status, and payments',
    path: '/settings/billing',
    icon: CreditCard,
  },
  {
    key: 'notifications',
    label: 'Notifications',
    description: 'Email reminders and summaries',
    path: '/settings/notifications',
    icon: Bell,
  },
  {
    key: 'regional',
    label: 'Regional',
    description: 'Timezone and follow-up timing',
    path: '/settings/regional',
    icon: Globe,
  },
  {
    key: 'about',
    label: 'About & Legal',
    description: 'App version, support, and policies',
    path: '/settings/about',
    icon: Info,
  },
];

export const getSettingsTitle = (pathname) => {
  if (pathname === '/settings/business-knowledge') return 'Business knowledge';
  if (pathname.startsWith('/settings/business-knowledge/pricing')) return 'Products & pricing';
  if (pathname.startsWith('/settings/business-knowledge/policies')) return 'Policies';
  const match = SETTINGS_CATEGORIES.find((item) => pathname.startsWith(item.path));
  return match ? match.label : 'Settings';
};
